import { render, staticRenderFns } from "./NoticeDetailx.vue?vue&type=template&id=066c2674&scoped=true"
import script from "./NoticeDetailx.vue?vue&type=script&lang=js"
export * from "./NoticeDetailx.vue?vue&type=script&lang=js"
import style0 from "./NoticeDetailx.vue?vue&type=style&index=0&id=066c2674&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "066c2674",
  null
  
)

export default component.exports